export default __webpack_public_path__ + "static/media/everycred-full-logo.34df76b3.svg";